import { render } from "./UserApp.vue?vue&type=template&id=09acb2c5"
import script from "./UserApp.vue?vue&type=script&lang=js"
export * from "./UserApp.vue?vue&type=script&lang=js"

import exportComponent from "/builds/apps/elevate/shepherd/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__